import WeeklyData from "Components/WeeklyData";

import type { IStepProps } from ".";

export default function Time({ data, setData }: IStepProps) {
  return (
    <WeeklyData
      data={data?.price}
      setData={(value) => setData("data", value)}
      text="قیمت"
      valueKey="price"
      label="قیمت (تومان)"
      activeDays={data?.general?.working_days}
    />
  );
}
